/* Kit Engreídos · JS de la landing — generado desde landing/js/main.js */
/* ==========================================================================
   Kit Engreídos · Landing — interacciones (v2 premium)
   Sin dependencias. Toda la configuración editable vive en CONFIG.
   ========================================================================== */
(function () {
  'use strict';

  // Gate de animaciones: sin JS todo queda visible
  document.documentElement.classList.add('js');

  /* ------------------------------------------------------------------
     CONFIGURACIÓN — editar aquí antes de publicar
     checkoutUrl: URL del checkout de Shopify. Dos formatos válidos:
       · Página de producto:  https://TU-TIENDA.com/products/kit-engreidos
       · Checkout directo:    https://TU-TIENDA.com/cart/VARIANT_ID:1
     Mientras esté vacío, los botones de compra llevan a la sección
     de precio (#precio) para que la página siga siendo navegable.
  ------------------------------------------------------------------ */
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- Botones de compra --------------------------------------------
     En Shopify el enlace (href) lo genera Liquid en el snippet eng-cta
     (apunta al carrito/checkout del producto). Aquí solo disparamos el
     evento de Meta Ads cuando el pixel esta instalado.                 */
  var buyButtons = document.querySelectorAll('.js-buy');
  buyButtons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (typeof window.fbq === 'function') {
        window.fbq('track', 'InitiateCheckout', {
          content_name: 'Kit Engreidos',
          content_category: btn.dataset.cta || 'landing',
          currency: 'PEN',
          value: 47.0
        });
      }
    });
  });

  /* ---- Contador regresivo de la barra de urgencia ---------------------
         Empieza en 44:00, persiste entre recargas (localStorage) y se
         reinicia automáticamente al llegar a cero.                       */
  var timerEl = document.getElementById('offerTimer');
  if (timerEl) {
    var OFFER_MS = (parseInt(timerEl.getAttribute('data-minutes'), 10) || 44) * 60 * 1000;
    var deadline = parseInt(localStorage.getItem('e_offer_deadline') || '0', 10);
    if (!deadline || deadline <= Date.now() || deadline - Date.now() > OFFER_MS) {
      deadline = Date.now() + OFFER_MS;
      localStorage.setItem('e_offer_deadline', String(deadline));
    }
    var renderTimer = function () {
      var left = deadline - Date.now();
      if (left <= 0) {
        deadline = Date.now() + OFFER_MS;
        localStorage.setItem('e_offer_deadline', String(deadline));
        left = OFFER_MS;
      }
      var total = Math.round(left / 1000);
      var m = Math.floor(total / 60);
      var s = total % 60;
      timerEl.textContent = (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
    };
    renderTimer();
    setInterval(renderTimer, 1000);
  }

  /* ---- Carrusel "Qué incluye" (escritorio): flechas + arrastre --------- */
  var modList = document.getElementById('modList');
  var modPrev = document.getElementById('modPrev');
  var modNext = document.getElementById('modNext');
  if (modList && modPrev && modNext) {
    var cardStep = function () {
      var card = modList.querySelector('.mod-card');
      return card ? card.getBoundingClientRect().width + 20 : 490;
    };
    var slide = function (dir) {
      modList.scrollBy({ left: dir * cardStep(), behavior: reduceMotion ? 'auto' : 'smooth' });
    };
    modPrev.addEventListener('click', function () { slide(-1); });
    modNext.addEventListener('click', function () { slide(1); });

    var syncNav = function () {
      modPrev.disabled = modList.scrollLeft <= 4;
      modNext.disabled = modList.scrollLeft >= modList.scrollWidth - modList.clientWidth - 4;
    };
    modList.addEventListener('scroll', syncNav, { passive: true });
    window.addEventListener('resize', syncNav);
    syncNav();

    // Arrastre con mouse (el touch ya funciona nativo)
    var dragging = false, dragStartX = 0, dragStartLeft = 0;
    modList.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse') return;
      dragging = true; dragStartX = e.clientX; dragStartLeft = modList.scrollLeft;
      modList.classList.add('dragging');
    });
    window.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      modList.scrollLeft = dragStartLeft - (e.clientX - dragStartX);
    });
    window.addEventListener('pointerup', function () {
      dragging = false;
      modList.classList.remove('dragging');
    });
  }

  /* ---- FAQ: al abrir una pregunta, cierra las demás ------------------ */
  var faqs = document.querySelectorAll('.faq');
  faqs.forEach(function (faq) {
    faq.addEventListener('toggle', function () {
      if (!faq.open) return;
      faqs.forEach(function (other) {
        if (other !== faq) other.open = false;
      });
    });
  });

  /* ---- Barra de compra fija: aparece al pasar el hero, se oculta
         cuando la sección de precio ya está a la vista ----------------- */
  var stickyBar = document.getElementById('stickyBuy');
  var hero = document.querySelector('.hero');
  var priceSection = document.getElementById('precio');

  if (stickyBar && hero && 'IntersectionObserver' in window) {
    var pastHero = false;
    var priceVisible = false;

    var updateBar = function () {
      var show = pastHero && !priceVisible;
      stickyBar.classList.toggle('show', show);
      stickyBar.setAttribute('aria-hidden', show ? 'false' : 'true');
    };

    new IntersectionObserver(function (entries) {
      pastHero = !entries[0].isIntersecting;
      updateBar();
    }, { threshold: 0 }).observe(hero);

    if (priceSection) {
      new IntersectionObserver(function (entries) {
        priceVisible = entries[0].isIntersecting;
        updateBar();
      }, { threshold: 0.15 }).observe(priceSection);
    }
  }

  /* ---- Contador animado de la franja de números ----------------------- */
  var counters = document.querySelectorAll('[data-count]');
  if (counters.length && !reduceMotion && 'IntersectionObserver' in window) {
    var counterObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        counterObserver.unobserve(entry.target);
        animateCount(entry.target);
      });
    }, { threshold: 0.6 });
    counters.forEach(function (el) { counterObserver.observe(el); });
  }

  function animateCount(el) {
    var target = parseInt(el.dataset.count, 10);
    var suffix = el.dataset.suffix || '';
    var duration = 900;
    var start = null;
    function tick(ts) {
      if (start === null) start = ts;
      var p = Math.min((ts - start) / duration, 1);
      var eased = 1 - Math.pow(1 - p, 3); // ease-out cúbico
      el.textContent = Math.round(target * eased) + suffix;
      if (p < 1) requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }

  /* ---- Aparición suave de secciones (respeta reduced-motion) --------- */
  var revealEls = document.querySelectorAll('.reveal');

  if (reduceMotion || !('IntersectionObserver' in window)) {
    revealEls.forEach(function (el) { el.classList.add('in'); });
  } else {
    var revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('in');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    revealEls.forEach(function (el) { revealObserver.observe(el); });
  }

  /* ---- Año dinámico en el footer -------------------------------------- */
  var yearEl = document.getElementById('year');
  if (yearEl) yearEl.textContent = String(new Date().getFullYear());
})();
